import { FEATURE_INFO_URL } from '../../../NonReact/constants/ApiConstants'
import { LicenceEntry } from '../../../NonReact/Types/Types'
import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { APIListData, JSONResponse } from '../../../NonReact/common/Types/Types'

/**
 * Get feature flag from AppLicense.xml file.
 *
 * @param flagName - Name of the flag to get.
 * @param asBoolean - Convert value to boolean?
 *
 * @returns - Promise resolving to the flag value.
 */
export function getFeatureFlag<T extends Definable<true | false>>(
    flagName: string,
    asBoolean: T
): T extends true ? Promise<Definable<boolean>> : Promise<Definable<string>>
export function getFeatureFlag<T extends Definable<true | false>>(
    flagName: string,
    asBoolean?: T
): Promise<Definable<string | boolean>> {
    return requestGetJSON<APIListData<LicenceEntry>>(FEATURE_INFO_URL, { cacheTime: 50000 }).then(
        (licenceFile: JSONResponse<APIListData<LicenceEntry>>): Definable<string | boolean> => {
            const licenceEntryValue: Nullable<string> = licenceFile?.Data?.Items?.find(
                (licenceEntry: LicenceEntry): boolean => licenceEntry.Name === flagName
            )?.Value

            return asBoolean ? licenceEntryValue === 'Yes' : licenceEntryValue
        }
    )
}
